import { LEAD_MARKETPLACE_PRODUCT_LABEL, PRODUCT_TYPES_OPTIONS, PRODUCT_TYPE_IDS } from 'helpers/sf_constants';
import _ from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useLeadMarketplace from './useLeadMarketplace';

const useDistinctAccountProductTypes = () => {
    const { campaigns, current_account } = useSelector(state => ({
        campaigns: state.Campaign.campaigns,
        current_account: state.accounts.current_account
    }))
    const { isLeadMarketplaceEnabled } = useLeadMarketplace(current_account);

    const accountProductTypeAvailability = useMemo(() => {
        const distinctProductTypes = _.uniq((campaigns || []).map(c => c?.product_type_id)).sort();
        const hasClicks = distinctProductTypes.includes(PRODUCT_TYPE_IDS.CLICKS);
        const hasCalls = distinctProductTypes.includes(PRODUCT_TYPE_IDS.CALLS);
        const hasLeads = distinctProductTypes.includes(PRODUCT_TYPE_IDS.LEADS);
        const hasSyndiClicks = distinctProductTypes.includes(PRODUCT_TYPE_IDS.SYNDI_CLICKS);
        const hasQuoteFunnels = distinctProductTypes.includes(PRODUCT_TYPE_IDS.QUOTE_FUNNELS);

        return {
            distinctProductTypes,
            hasClicks,
            hasCalls,
            hasLeads,
            hasSyndiClicks,
            hasQuoteFunnels
        }
    }, [campaigns]);

    const availableProductTypeOptions = useMemo(() => {
        return isLeadMarketplaceEnabled && accountProductTypeAvailability.hasLeads
            ? [...PRODUCT_TYPES_OPTIONS, {
                value: PRODUCT_TYPE_IDS.LEADS,
                label: LEAD_MARKETPLACE_PRODUCT_LABEL
            }]
            : PRODUCT_TYPES_OPTIONS;
    }, [accountProductTypeAvailability, isLeadMarketplaceEnabled]);

    const state = {
        availableProductTypeOptions,
        ...accountProductTypeAvailability
    }

    return state;
}

export default useDistinctAccountProductTypes;
